module.exports = __webpack_public_path__ + "static/media/kings2.6bd6f45f.png";